import { decrementRequestCounter, incrementRequestCounter, resetRequestCounter } from 'FRONTEND/actions/app';
import { DECREMENT_REQUEST_COUNTER, INCREMENT_REQUEST_COUNTER } from 'FRONTEND/actions/constants';
import { MAX_LOADING_TIME } from 'FRONTEND/utils/constants';

// remove `_REQUEST`, `_SUCCESS` or `_ERROR` in action type
const regex = /^(.*)_[^_]*$/;
// remove `Request`, `Success` or `Error` in action type
const sliceRegex = /^(.*)[A-Z][a-z]*$/;
// remove `/pending`, `/fulfilled` or `/rejected` in action type
const thunkRegex = /^(.*)\/[a-z]*$/;

let timeoutId;

const loader = (store) => (next) => (action) => {
  if (action.type.endsWith('_REQUEST') || action.type?.endsWith('Request') || action.type.endsWith('/pending')) {
    store.dispatch(incrementRequestCounter({ type: action.type }));
    return next(action);
  }

  if (action.type.endsWith('_SUCCESS') || action.type?.endsWith('Success') || action.type.endsWith('/fulfilled') || action.type.endsWith('_ERROR') || action.type.endsWith('Error') || action.type.endsWith('/rejected')) {
    next(action);
    let type;
    if (action.type.endsWith('_SUCCESS') || action.type.endsWith('_ERROR')) {
      type = `${action.type.match(regex)[1]}_REQUEST`;
    } else if (action.type.endsWith('Success') || action.type.endsWith('Error')) {
      type = `${action.type.match(sliceRegex)[1]}Request`;
    } else {
      type = `${action.type.match(thunkRegex)[1]}/pending`;
    }
    return store.dispatch(decrementRequestCounter({ type }));
  }

  switch (action.type) {
    case INCREMENT_REQUEST_COUNTER:
      if (!store.getState().calendar.isLoading) {
        timeoutId = setTimeout(() => {
          store.dispatch(resetRequestCounter());
        }, MAX_LOADING_TIME);
      }
      return next(action);

    case DECREMENT_REQUEST_COUNTER:
      next(action);
      if (!store.getState().calendar.isLoading) {
        clearTimeout(timeoutId);
      }
      break;

    default:
      next(action);
  }
};

export default loader;
